import { inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Apollo } from 'apollo-angular';
import { ActivatedRoute } from '@angular/router';
import { GET_PAYMENT_METHODS } from '@admin/modules/payment-method/graphql/payment-method.graphql';
import { map } from 'rxjs/operators';
import { ulid } from 'ulid';
import { GET_PHASES } from '@modules/campaigns/services/graphQl/phase-graphql';

@Injectable({
  providedIn: 'root',
})
export class PhasesService {
  private apollo = inject(Apollo);
  private route = inject(ActivatedRoute);

  getPhases(): Observable<any> {
    const criteria = {
      filters: {
        tenantId: this.route.snapshot.queryParamMap.get('tenant'),
      },
    };
    return this.apollo
      .watchQuery({
        query: GET_PHASES,
        variables: { criteria },
      })
      .valueChanges.pipe(map((result: any) => result.data));
  }
}
